import axios from '../request/http';

const Login = {
    // 获取验证码
    getCode(params) {
        return axios.get("/proxy/admin/captcha");
    },
    // 登录
    login(params) {
        return axios.get("/proxy/admin/login",{params});
    },
}

export default Login;


// WEBPACK FOOTER //
// ./src/api/Login.js